"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useView = void 0;
var _react = require("react");
var _hooks = require("../../../../hooks");
const useView = () => {
  const {
    isMobileView,
    isDeviceDataReady
  } = (0, _hooks.useDeviceData)();
  const [isErrorMessage, setIsErrorMessage] = (0, _react.useState)(false);
  const [view, setView] = (0, _react.useState)('inline');
  const [viewIndex, setViewIndex] = (0, _react.useState)({
    inline: 0,
    groupsSelector: 0,
    studentsSelector: 0,
    createGroup: 0,
    groupEdit: 0
  });
  (0, _react.useEffect)(() => {
    if (isDeviceDataReady) {
      let newView = view || 'inline';
      if (isMobileView && view === 'createGroup' || !isMobileView && view === 'groupsSelector') {
        newView = 'inline';
      }
      if (newView !== view) {
        setView(newView);
      }
    }
  }, [view, isDeviceDataReady, isMobileView]);
  const setViewAndIndex = (0, _react.useCallback)((view, index) => {
    if (view && Object.keys(viewIndex).indexOf(view) >= 0) {
      let newViewIndex = {
        ...viewIndex
      };
      newViewIndex[view] = index || 0;
      setIsErrorMessage(view === 'studentsSelector' && index === 2 || view === 'createGroup' && index === 3);
      setViewIndex(newViewIndex);
      setView(view);
    }
  }, [viewIndex]);
  return {
    view,
    viewIndex,
    setViewAndIndex,
    isErrorMessage
  };
};
exports.useView = useView;